<template>
    <iframe
        v-if="data?.videoSource"
        v-bind="attributes"
        frameborder="0"
        allowfullscreen
    />
    <img
        v-else-if="props.data?.imageSource"
        v-bind="attributes"
        :alt="data?.source"
    />
</template>

<script setup>
import { defineProps, onMounted, ref } from "vue"

const props = defineProps({
    data: {
        type: Object,
        required: true,
    }
})

const aspectRatio = props.data?.videoAspectRatio ?? props.data?.imageAspectRatio

const attributes = ref({
    id: props.data?.id,
    src: props.data?.videoSource || getImageSourceWithHash(),
    style: aspectRatio ? `height: auto; aspect-ratio: ${aspectRatio};` : '',
    width: '100%',
})

function getImageSourceWithHash() {
    return `${props.data?.imageSource}?t=${Date.now()}`
}

onMounted(() => {
    if (props.data?.imageUpdateInterval > 0) {
        setInterval(() => {
            attributes.value.src = getImageSourceWithHash()
        }, parseInt(props.data?.imageUpdateInterval) * 1000)
    }
})
</script>
